import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { db } from "../config/firebase"; // Firestore configuration
import { doc, getDoc } from "firebase/firestore"; // Firestore methods
import NavBar from "../components/navbar";
import Footer from "../components/footer";

const BlogDetails = () => {
  const { blogid } = useParams(); // Get blogid from URL
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const blogRef = doc(db, "Blogs", blogid); // Replace "blogs" with your Firestore collection name
        const blogSnap = await getDoc(blogRef);

        if (blogSnap.exists()) {
          setBlog(blogSnap.data());
        } else {
          console.error("No such document!");
        }
      } catch (error) {
        console.error("Error fetching blog:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [blogid]);

  if (loading) {
    return (
      <div className="loading-container">
        <p>Loading...</p>
      </div>
    );
  }

  if (!blog) {
    return (
      <div className="error-container">
        <p>Blog not found!</p>
      </div>
    );
  }

  return (
    <div className="page-container">
      <NavBar />
      <div className="blog-details">
        <div
          className="content"
          dangerouslySetInnerHTML={{ __html: blog.content }}
        />
      </div>
      <Footer />
      <style jsx>{`
        .page-container {
          background: linear-gradient(135deg, #f0f0f0, #e0e0e0);
          min-height: 100vh;
        }

        .blog-details {
          max-width: 1200px;
          margin: 55px auto;
          padding: 20px;
        }

        .blog-details h1 {
          font-size: 3rem;
          font-weight: bold;
          color: #333;
          margin-bottom: 20px;
          text-align: center;
        }

        .blog-details p {
          font-size: 1.2rem;
          color: #555;
          margin-bottom: 30px;
          text-align: left;
        }

        .blog-details .content {
          font-size: 1.1rem;
          color: #333;
          line-height: 1.8;
          margin-bottom: 40px;
        }

        .loading-container,
        .error-container {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 50vh;
          color: #333;
          font-size: 1.2rem;
        }

        @media (max-width: 768px) {
          .blog-details {
            padding: 15px;
          }

          .blog-details h1 {
            font-size: 2.5rem;
          }

          .blog-details p {
            font-size: 1rem;
          }

          .blog-details .content {
            font-size: 1rem;
          }
        }

        @media (max-width: 480px) {
          .blog-details h1 {
            font-size: 2rem;
          }

          .blog-details p {
            font-size: 0.9rem;
          }

          .blog-details .content {
            font-size: 0.9rem;
          }
        }
      `}</style>
    </div>
  );
};

export default BlogDetails;
